import { environment } from 'src/environments/environment';

export const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const CREDENTIALS_REGEX = '[a-zA-Z 0-9- @_. ]{0,256}$';
export const CURP_REGEX = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;
export const RFC_REGEX = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;
export const NAME_REGEX = '[a-zA-ZáéíóúÁÉÍÚÓñÑüÜ ][a-zA-ZáéíóúñÁÉÍÚÓÑüÜ ]{2,30}$';
export const SKELETON_LIST = [1, 2, 3, 4, 5, 6, 7, 8];
export const WITHOUT_NUMBER_REGEX = /^S\/N$/;
export const NUMBER_REGEX = /^\d+$/;
export const INT_NUMBER = '[a-zA-Z 0-9- ]{0,256}$';
export const DEFAULT_LANGUAGE = 'es';
export const MIN_EXPIRATION_DATE = 4;
export const MAX_SIZE_FILE = 5242880;
export const MIN_CARD_NUMBER = 13;
export const MAX_CARD_NUMBER = 16;
export const MAX_LENGTH_PASS = 20;
export const MIN_LENGTH_PASS = 8;
export const MIN_CVV = 3;
export const NEW_PASS_REGEX = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9-@_.]+)$/;

export const ACTIONS_TOOLBAR = [
    { label: 'HOME.TOOLBAR.weeklyOffer', route: '/ofertas' },
    { label: 'HOME.TOOLBAR.lists', route: '/listas-alsuper' },
    { label: 'HOME.TOOLBAR.club', route: '/club-alsuper' },
    { label: 'HOME.TOOLBAR.card', route: '/alsuper-card' }
];

export const ALSUPER_LIST = [
    { label: 'HOME.TOOLBAR.club', route: 'club-alsuper' },
    { label: 'HOME.TOOLBAR.card', route: 'alsuper-card' },
    { label: 'HOME.TOOLBAR.weeklyOffer', route: 'ofertas' },
    { label: 'HOME.TOOLBAR.lists', route: 'listas-alsuper' },
    { label: 'FOOTER.billing', route: 'facturacion' }
];

export const LIVESUPER_LIST = [
    { label: 'HOME.TOOLBAR.ourRecipes', route: 'recetas' },
    { label: 'FOOTER.grill', route: 'al-asador' },
    { label: 'FOOTER.localConsume', route: 'consume-local' },
];

export const JOIN_THE_TEAM_LIST = [
    { label: 'FOOTER.becomeShopper', route: environment.shopperUrl }
];

export const HELP_LIST = [
    { label: 'FOOTER.findYourStore', route: 'tiendas' },
    { label: 'FOOTER.helpCenter', route: 'ayuda' }
];

export const HELP_LIST_SHOPPER = [
    { label: 'FAQ', route: '' },
    { label: 'FOOTER.helpCenter', route: '/ayuda' },
    { label: 'FOOTER.phonesEmail', route: '' }
];

export const CORP_LIST = [
    { label: 'FOOTER.terms', route: '/nosotros/terminos' },
    { label: 'FOOTER.privacy', route: '/nosotros/privacidad' }
];

export const CORP_LIST_SHOPPER = [
    { label: 'FOOTER.whoWeAre', route: '/' },
    { label: 'FOOTER.terms', route: '/' },
    { label: 'FOOTER.privacy', route: '/' }
];

export const ALLIES_LIST = [
    { label: 'ANTAD', route: 'https://antad.net' },
    { label: 'Locales Comerciales', route: 'http://www.asiinmobiliaria.com' },
    { label: 'Importaciones', route: 'http://cedisnapp.alsuper.com:2020/cedis/login.aspx' },
    { label: 'Proveedores', route: 'https://proveedores.alsuper.com/' },
    { label: 'Citas a proveedor', route: '' },
];

export const FOOTER_LIST_MOBILE = [
    { header: 'Alsuper', list: ALSUPER_LIST, open: false },
    { header: 'FOOTER.allies', list: ALLIES_LIST, open: false },
    { header: 'FOOTER.liveAlSuper', list: LIVESUPER_LIST, open: false },
    { header: 'AUTH.help', list: HELP_LIST, open: false },
    { header: 'FOOTER.joinUs', list: JOIN_THE_TEAM_LIST, open: false },
];

export const CEDIS_LIST = [
    { label: 'CEDIS CHIHUAHUA', route: 'http://citas.alsuper.com:1702/CEDIS/LoginCitas.aspx?IDBodega=92' },
    { label: 'CEDIS NORESTE', route: 'http://citas.alsuper.com:1703/CEDIS/LoginCitas.aspx?IDBodega=95' }
];

export const MENU_LIST = [
    { label: 'MENU.profile', route: '/perfil/mi-perfil', icon: 'ic-account' },
    { label: 'MENU.purchases', route: '/perfil/compras', icon: 'ic-purchases' },
    { label: 'MENU.paymentMethods', route: '/perfil/metodos-de-pago', icon: 'ic-payment-methods' },
    { label: 'MENU.addresses', route: '/perfil/direcciones', icon: 'ic-addresses' },
    { label: 'ACCESSIBILITY.preferences', route: 'preferences', icon: 'ic-preferences' }
];

export const ADDRESSES_TAG = [
    { label: 'ADDRESSES.house', name: 'Casa', icon: 'ic-house' },
    { label: 'ADDRESSES.office', name: 'Oficina', icon: 'ic-office' },
    { label: 'ADDRESSES.parents', name: 'Papás', icon: 'ic-pin' },
    { label: 'ADDRESSES.couple', name: 'Pareja', icon: 'ic-couple' },
    { label: 'ADDRESSES.other', name: 'Otra', icon: 'ic-other' }
];

export const PREFERENCES_LIST = [
    {
        message: 'ACCESSIBILITY.delivery_without_bags',
        subMessage: 'ACCESSIBILITY.callForOpt',
        control: 'delivery_without_bags',
        value: false
    },
    {
        message: 'ACCESSIBILITY.receive_messages_calls',
        subMessage: 'ACCESSIBILITY.wontCall',
        control: 'receive_messages_calls',
        value: false
    },
    {
        message: 'ACCESSIBILITY.change_products',
        subMessage: 'ACCESSIBILITY.leaveYourOrderInsideYourHome',
        control: 'change_products',
        value: false
    },
    {
        message: 'ACCESSIBILITY.disability_physical_mental',
        subMessage: 'ACCESSIBILITY.leaveYourOrderInsideYourHome',
        control: 'disability_physical_mental',
        value: false
    }
];

export const DISABILITIES = [
    { disability: 'ACCESSIBILITY.visual', value: 1 },
    { disability: 'ACCESSIBILITY.auditory', value: 2 },
    { disability: 'ACCESSIBILITY.physical', value: 3 }
];

export const GENDER_TAG = [
    { label: 'MYPROFILE.maleGender', name: 'H', icon: 'ic-man' },
    { label: 'MYPROFILE.femaleGender', name: 'M', icon: 'ic-women' }
];

export const LIVE_YOUR_SUPER = [
    { image: 'assets/images/recipes.png', route: '/recetas' },
    { image: 'assets/images/grill-c.png', route: '/al-asador' },
    { image: 'assets/images/consume-local.png', route: '/consume-local' },
];

export const AUTH_FOOTER = [
    { label: 'FOOTER.terms', route: '/nosotros/terminos' },
    { label: 'AUTH.privacy', route: '/nosotros/privacidad' },
    { label: 'AUTH.help', route: '/ayuda' },
];

export const HELP_BUTTONS = [
    { label: 'HELP.howToBuy', active: 'how' },
    { label: 'HELP.shippingPickup', active: 'shipping' },
    { label: 'HELP.returns', active: 'returns' },
    { label: 'HELP.myAccount', active: 'account' },
    { label: 'HELP.payments', active: 'payments' },
    { label: 'COVID-19', active: 'covid' },
    { label: 'HELP.paymentsForms', active: 'promos' },
    { label: 'FOOTER.billing', active: 'billing' }
];

export const CONTACT_BUTTONS = [
    { label: 'HELP.contactTo', icon: 'ic-talk' },
    { label: 'HELP.mailTo', icon: 'ic-mail' }
];

export const HOW_TO_BUY_BUTTONS = [
    { label: 'HELP.HOWTOBUY.opt1', active: 'pay' },
    { label: 'HELP.HOWTOBUY.opt2', active: 'pay' },
    { label: 'HELP.HOWTOBUY.opt3', active: 'pay' },
    { label: 'HELP.HOWTOBUY.opt4', active: 'pay' },
    { label: 'HELP.HOWTOBUY.opt5', active: 'pay' },
    { label: 'HELP.HOWTOBUY.opt6', active: 'pay' },
    { label: 'HELP.HOWTOBUY.opt7', active: 'pay' },
    { label: 'HELP.HOWTOBUY.opt8', active: 'pay' },
    { label: 'HELP.HOWTOBUY.opt9', active: 'pay' },
    { label: 'HELP.HOWTOBUY.opt10', active: 'pay' },
    { label: 'HELP.HOWTOBUY.opt11', active: 'pay' },
    { label: 'HELP.HOWTOBUY.opt12', active: 'pay' },
    { label: 'HELP.HOWTOBUY.opt13', active: 'pay' }
];

export const PICKUP_BUTTONS = [
    { label: 'HELP.PICKUP.options', active: 'pay', answer: 'HELP.PICKUP.options-asw' },
    { label: 'HELP.PICKUP.request', active: 'purchase', answer: 'HELP.PICKUP.request-asw' },
    { label: 'HELP.PICKUP.received', active: 'points', answer: 'HELP.PICKUP.received-asw' },
    { label: 'HELP.PICKUP.order', active: 'delivery', answer: 'HELP.PICKUP.order-asw' },
    { label: 'HELP.PICKUP.came', active: 'guarantee', answer: 'HELP.PICKUP.came-asw' }
];

export const RETURNS_BUTTONS = [
    { label: 'HELP.RETURNS.damage', active: 'pay', answer: 'HELP.RETURNS.damage-asw' },
    { label: 'HELP.RETURNS.wrong', active: 'purchase', answer: 'HELP.RETURNS.wrong-asw' },
    { label: 'HELP.RETURNS.cases', active: 'points', answer: 'HELP.RETURNS.cases-asw' },
    { label: 'HELP.RETURNS.back', active: 'delivery', answer: 'HELP.RETURNS.back-asw' },
    { label: 'HELP.RETURNS.info', active: 'guarantee', answer: 'HELP.RETURNS.info-asw' }
];

export const ACCOUNT_BUTTONS = [
    { label: 'HELP.ACCOUNT.how', active: 'pay', answer: 'HELP.ACCOUNT.how-asw' },
    { label: 'HELP.ACCOUNT.more', active: 'purchase', answer: 'HELP.ACCOUNT.more-asw' },
    { label: 'HELP.ACCOUNT.access', active: 'points', answer: 'HELP.ACCOUNT.access-asw' },
    { label: 'HELP.ACCOUNT.enter', active: 'delivery', answer: 'HELP.ACCOUNT.enter-asw' },
    { label: 'HELP.ACCOUNT.changePass', active: 'guarantee', answer: 'HELP.ACCOUNT.changePass-asw' },
    { label: 'HELP.ACCOUNT.orderReg', active: 'refund', answer: 'HELP.ACCOUNT.orderReg-asw' },
    { label: 'HELP.ACCOUNT.office', active: 'refund', answer: 'HELP.ACCOUNT.office-asw' },
    { label: 'HELP.ACCOUNT.help', active: 'refund', answer: 'HELP.ACCOUNT.help-asw' }
];

export const PAYMENTS_BUTTONS = [
    { label: 'HELP.PAYMENTS.howToPay', active: 'pay', answer: 'HELP.PAYMENTS.howToPay-asw' },
    { label: 'HELP.PAYMENTS.minPurchase', active: 'purchase', answer: 'HELP.PAYMENTS.minPurchase-asw' },
    { label: 'HELP.PAYMENTS.purchasePoints', active: 'points', answer: 'HELP.PAYMENTS.purchasePoints-asw' },
    { label: 'HELP.PAYMENTS.deliverySchedule', active: 'delivery', answer: 'HELP.PAYMENTS.deliverySchedule-asw' },
    { label: 'HELP.PAYMENTS.ordersGuarantee', active: 'guarantee', answer: 'HELP.PAYMENTS.ordersGuarantee-asw' },
    { label: 'HELP.PAYMENTS.refundPolicy', active: 'refund', answer: 'HELP.PAYMENTS.refundPolicy-asw' },
];

export const COVID_BUTTONS = [
    { label: 'HELP.COVID.prevent', active: 'pay', answer: 'HELP.COVID.prevent-asw' },
    { label: 'HELP.COVID.have', active: 'purchase', answer: 'HELP.COVID.have-asw' }
];

export const PRODUCTS_BUTTONS = [
    { label: 'HELP.FORMSPAY.options', active: 'pay', answer: 'HELP.FORMSPAY.options-asw', answer1: '' },
    { label: 'HELP.FORMSPAY.cards', active: 'purchase', answer: 'HELP.FORMSPAY.cards-asw', answer1: 'HELP.FORMSPAY.cards-asw1' },
    { label: 'HELP.FORMSPAY.discount', active: 'points', answer: 'HELP.FORMSPAY.discount-asw', answer1: '' },
    { label: 'HELP.FORMSPAY.concept', active: 'delivery', answer: 'HELP.FORMSPAY.concept-asw', answer1: 'HELP.FORMSPAY.concept-asw1' }
];

export const BILLING_BUTTONS = [
    { label: 'HELP.BILLING.request', active: 'pay', answer: 'HELP.BILLING.request-asw' },
    { label: 'HELP.BILLING.bill', active: 'purchase', answer: 'HELP.BILLING.bill-asw' },
    { label: 'HELP.BILLING.seeBills', active: 'points', answer: 'HELP.BILLING.seeBills-asw' }
];

export const TERMS_EXPANSION_LIST = [
    { header: 'TERMS.terms&conditions', body: 'TERMS.terms&conditionsBody' },
    { header: 'TERMS.generalDisposition', body: 'TERMS.generalDispositionBody' },
    { header: 'TERMS.usersSignup', body: 'TERMS.usersSignupBody' },
    { header: 'TERMS.usersObligations', body: 'TERMS.usersObligationsBody' },
    { header: 'TERMS.security', body: 'TERMS.securityBody' },
    { header: 'TERMS.eCommerce', body: 'TERMS.eCommerceBody' },
    { header: 'TERMS.purchaseProcess', body: 'TERMS.purchaseProcessBody' },
    { header: 'TERMS.serviceCoverae', body: 'TERMS.serviceCoveraeBody' },
    { header: 'TERMS.deliveryMechanics', body: 'TERMS.deliveryMechanicsBody' },
    { header: 'TERMS.deliveryCharge', body: 'TERMS.deliveryChargeBody' },
    { header: 'TERMS.deliverySchedule', body: 'TERMS.deliveryScheduleBody' },
    { header: 'TERMS.paymentMethods', body: 'TERMS.paymentMethodsBody' },
    { header: 'TERMS.returnGaranteeRefund', body: 'TERMS.returnGaranteeRefundBody' },
    { header: 'TERMS.promos', body: 'TERMS.promosBody' },
    { header: 'TERMS.refund', body: 'TERMS.refundBody' },
    { header: 'TERMS.contactMedia', body: 'TERMS.contactMediaBody' },
    { header: 'TERMS.billing', body: 'TERMS.billingBody' },
    { header: 'TERMS.contactHour', body: 'TERMS.contactHourBody' },
    { header: 'TERMS.final', body: 'TERMS.finalBody' }
];

export const DEPARTMENTS_LIST = [
    {
        label: 'DEPARTMENTS.fruitsVegetables',
        icon: 'ic-fruit',
        route: 'fruit',
        open: false,
        queryParam: 'FRUTAS Y VERDURAS',
        banner: 'assets/images/departments_categories/FrutasVerduras/Banner_Departamento_Frutas_Verduras_alsuper.jpg',
        sections: [
            {
                queryParam: 'FRUTAS',
                label: 'DEPARTMENTS.fruits',
                mini: 'assets/images/departments_categories/FrutasVerduras/Categorias/SubcategoriaFrutas.jpg',
                banner: 'assets/images/departments_categories/FrutasVerduras/Categorias/Banner_SubcategoriaFrutas.jpg'

            },
            {
                queryParam: 'VERDURAS',
                label: 'DEPARTMENTS.vegetables',
                mini: 'assets/images/departments_categories/FrutasVerduras/Categorias/Banner_SubcategoriaVerduras.jpg',
                banner: 'assets/images/departments_categories/FrutasVerduras/Categorias/Banner_SubcategoriaVerduras.jpg'
            },
            {
                queryParam: 'GRANOS',
                label: 'DEPARTMENTS.seeds',
                mini: 'assets/images/departments_categories/FrutasVerduras/Categorias/SubcategoriaGranosSemillasChiles.jpg',
                banner: 'assets/images/departments_categories/FrutasVerduras/Categorias/Banner_SubcategoriaGranosSemillasChiles.jpg'
            },
            {
                queryParam: 'DESINFECTANTES',
                label: 'DEPARTMENTS.disinfectants',
                mini: 'assets/images/departments_categories/FrutasVerduras/Categorias/SubcategoriaDesinfectantes.jpg',
                banner: 'assets/images/departments_categories/FrutasVerduras/Categorias/Banner_SubcategoriaDesinfectantes.jpg'
            },
            {
                queryParam: '',
                label: 'DEPARTMENTS.greens',
                mini: 'assets/images/departments_categories/FrutasVerduras/Categorias/SubcategoriaHortalizas.jpg',
                banner: 'assets/images/departments_categories/FrutasVerduras/Categorias/Banner_SubcategoriaHortalizas.jpg'
            }
        ]
    },
    {
        label: 'DEPARTMENTS.pantry',
        icon: 'ic-pantry',
        route: 'pantry',
        open: false,
        queryParam: 'DESPENSA',
        sections: [
            {
                queryParam: 'SOPAS Y PASTAS',
                label: 'DEPARTMENTS.soups',
                mini: 'assets/images/departments_categories/Despensa/Categorias/SubcategoriaSopasPastasInstantaneos.jpg',
                banner: 'assets/images/departments_categories/Despensa/Categorias/Banner_SubcategoriaSopasPastasInstantaneos.jpg'
            },
            {
                queryParam: 'ACEITES',
                label: 'DEPARTMENTS.oils',
                mini: 'assets/images/departments_categories/Despensa/Categorias/SubcategoriaAceites.jpg',
                banner: 'assets/images/departments_categories/Despensa/Categorias/Banner_SubcategoriaAceites.jpg'
            },
            {
                queryParam: 'GRANOS',
                label: 'DEPARTMENTS.grains',
                mini: 'assets/images/departments_categories/Despensa/Categorias/SubcategoriaGranos.jpg',
                banner: 'assets/images/departments_categories/Despensa/Categorias/Banner_SubcategoriaGranos.jpg'
            },
            {
                queryParam: 'HARINAS',
                label: 'DEPARTMENTS.flours',
                mini: 'assets/images/departments_categories/Despensa/Categorias/SubcategoriaHarinasReposteria.jpg',
                banner: 'assets/images/departments_categories/Despensa/Categorias/Banner_SubcategoriaHarinasReposteria.jpg'
            },
            {
                queryParam: 'AZUCAR',
                label: 'DEPARTMENTS.sugar',
                mini: 'assets/images/departments_categories/Despensa/Categorias/SubcategoriaAzucar.jpg',
                banner: 'assets/images/departments_categories/Despensa/Categorias/Banner_SubcategoriaAzucar.jpg'
            },
            {
                queryParam: 'SAL',
                label: 'DEPARTMENTS.salt',
                mini: 'assets/images/departments_categories/Despensa/Categorias/SubcategoriaSal.jpg',
                banner: 'assets/images/departments_categories/Despensa/Categorias/Banner_SubcategoriaSal.jpg'
            },
            {
                queryParam: 'MIELES',
                label: 'DEPARTMENTS.honey',
                mini: 'assets/images/departments_categories/Despensa/Categorias/SubcategoriaMielMermeladas.jpg',
                banner: 'assets/images/departments_categories/Despensa/Categorias/Banner_SubcategoriaMielMermeladas.jpg'
            },
            {
                queryParam: 'VARIEDAD COMIDA ORIENTAL',
                label: 'DEPARTMENTS.asian',
                mini: 'assets/images/departments_categories/Despensa/Categorias/SubcategoriaVariedadComidaOriental.jpg',
                banner: 'assets/images/departments_categories/Despensa/Categorias/Banner_SubcategoriaVariedadComidaOriental.jpg'
            },
            {
                queryParam: 'ESPECIAS',
                label: 'DEPARTMENTS.spices',
                mini: 'assets/images/departments_categories/Despensa/Categorias/SubcategoriaEspeciasSazonadores.jpg',
                banner: 'assets/images/departments_categories/Despensa/Categorias/Banner_SubcategoriaEspeciasSazonadores.jpg'
            },
            {
                queryParam: 'LATERÍA Y ENVASADOS',
                label: 'DEPARTMENTS.tin',
                mini: 'assets/images/departments_categories/Despensa/Categorias/SubcategoriaLateriaEnvasados.jpg',
                banner: 'assets/images/departments_categories/Despensa/Categorias/Banner_SubcategoriaLateriaEnvasados.jpg'
            },
            {
                queryParam: 'GALLETAS DULCES, CEREALES, AVENA',
                label: 'DEPARTMENTS.cookies',
                mini: 'assets/images/departments_categories/Despensa/Categorias/SubcategoriaGalletasCerealesAvena.jpg',
                banner: 'assets/images/departments_categories/Despensa/Categorias/Banner_SubcategoriaGalletasCerealesAvena.jpg'
            },
            {
                queryParam: 'CAFES, TES',
                label: 'DEPARTMENTS.chocolate',
                mini: 'assets/images/departments_categories/Despensa/Categorias/SubcategoriaChocolatesCafesTes.jpg',
                banner: 'assets/images/departments_categories/Despensa/Categorias/Banner_SubcategoriaChocolatesCafesTes.jpg'
            },
            {
                queryParam: 'BOTANAS',
                label: 'DEPARTMENTS.snacks',
                mini: 'assets/images/departments_categories/Despensa/Categorias/SubcategoriaBotanas.jpg',
                banner: 'assets/images/departments_categories/Despensa/Categorias/Banner_SubcategoriaBotanas.jpg'
            },
            {
                queryParam: '',
                label: 'DEPARTMENTS.bulk',
                mini: 'assets/images/departments_categories/Despensa/Categorias/SubcategoriaProductosGranel.jpg',
                banner: 'assets/images/departments_categories/Despensa/Categorias/Banner_SubcategoriaProductosGranel.jpg'
            },
            {
                queryParam: 'DULCES',
                label: 'DEPARTMENTS.candies',
                mini: 'assets/images/departments_categories/Despensa/Categorias/SubcategoriaDulces.jpg',
                banner: 'assets/images/departments_categories/Despensa/Categorias/Banner_SubcategoriaDulces.jpg'
            },
        ],
        banner: 'assets/images/departments_categories/Despensa/Banner_Departamento_Despensa_alsuper.jpg'
    },
    {
        label:
            'DEPARTMENTS.meatSeafood',
        icon: 'ic-meat',
        route: 'meat',
        open: false,
        queryParam: 'CARNE ENLATADA, PESCADOS, MARISCOS',
        sections: [
            {
                queryParam: 'AVE, OTRAS AVES',
                label: 'DEPARTMENTS.birds',
                mini: 'assets/images/departments_categories/CarnesPescadosMariscos/Categorias/SubcategoriaAves.jpg',
                banner: 'assets/images/departments_categories/CarnesPescadosMariscos/Categorias/Banner_SubcategoriaAves.jpg'
            },
            {
                queryParam: 'PESCADOS',
                label: 'DEPARTMENTS.fishShop',
                mini: 'assets/images/departments_categories/CarnesPescadosMariscos/Categorias/SubcategoriaPescaderia.jpg',
                banner: 'assets/images/departments_categories/CarnesPescadosMariscos/Categorias/Banner_SubcategoriaPescaderia.jpg'
            },
            {
                queryParam: 'CARNES',
                label: 'DEPARTMENTS.beef',
                mini: 'assets/images/departments_categories/CarnesPescadosMariscos/Categorias/SubcategoriaRes.jpg',
                banner: 'assets/images/departments_categories/CarnesPescadosMariscos/Categorias/Banner_SubcategoriaRes.jpg'
            },
            {
                queryParam: 'TOCINOS, JAMON',
                label: 'DEPARTMENTS.pig',
                mini: 'assets/images/departments_categories/CarnesPescadosMariscos/Categorias/SubcategoriaPuerco.jpg',
                banner: 'assets/images/departments_categories/CarnesPescadosMariscos/Categorias/Banner_SubcategoriaPuerco.jpg'
            }
        ],
        banner: 'assets/images/departments_categories/CarnesPescadosMariscos/Departamento_Carnes_Pescados_Mariscos_alsuper.jpg'
    },
    {
        label: 'DEPARTMENTS.dairyEggs',
        icon: 'ic-dairy-eggs',
        route: 'dairy',
        open: false,
        queryParam: 'PRODUCTO LACTEO',
        sections: [
            {
                queryParam: 'LECHES, LECHE EN POLVO, LECHES Y FORMULAS',
                label: 'DEPARTMENTS.milk',
                mini: 'assets/images/departments_categories/LechesHuevos/Categorias/SubcategoriaLeches.jpg',
                banner: 'assets/images/departments_categories/LechesHuevos/Categorias/Banner_SubcategoriaLeches.jpg'
            },
            {
                queryParam: 'PRODUCTO LACTEO',
                label: 'DEPARTMENTS.dairy',
                mini: 'assets/images/departments_categories/LechesHuevos/Categorias/SubcategoriaLacteos.jpg',
                banner: 'assets/images/departments_categories/LechesHuevos/Categorias/Banner_SubcategoriaLacteos.jpg'
            },
            {
                queryParam: 'YOGHURT BATIDO',
                label: 'DEPARTMENTS.yogurt',
                mini: 'assets/images/departments_categories/LechesHuevos/Categorias/SubcategoriaYoghurtBebible.jpg',
                banner: 'assets/images/departments_categories/LechesHuevos/Categorias/Banner_SubcategoriaYoghurtBebible.jpg'
            },
            {
                queryParam: 'HUEVO',
                label: 'DEPARTMENTS.egg',
                mini: 'assets/images/departments_categories/LechesHuevos/Categorias/SubcategoriaHuevo.jpg',
                banner: 'assets/images/departments_categories/LechesHuevos/Categorias/Banner_SubcategoriaHuevo.jpg'
            }
        ],
        banner: 'assets/images/departments_categories/LechesHuevos/Banner_Departamento_Leches_Huevos_alsuper.jpg'
    },
    {
        label: 'DEPARTMENTS.cheeseDelicatessen',
        icon: 'ic-delicatessen',
        route: 'delicatessen',
        open: false,
        queryParam: 'QUESOS, SALCHICHAS',
        sections: [
            {
                queryParam: 'QUESOS, QUESO CREMA',
                label: 'DEPARTMENTS.cheese',
                mini: 'assets/images/departments_categories/QuesosSalchichoneria/Categorias/SubcategoriaQuesos.jpg',
                banner: 'assets/images/departments_categories/QuesosSalchichoneria/Categorias/Banner_SubcategoriaQuesos.jpg'
            },
            {
                queryParam: 'SALCHICHAS',
                label: 'DEPARTMENTS.delicatessen',
                mini: 'assets/images/departments_categories/QuesosSalchichoneria/Categorias/SubcategoriaSalchichoneria.jpg',
                banner: 'assets/images/departments_categories/QuesosSalchichoneria/Categorias/Banner_SubcategoriaSalchichoneria.jpg'
            }
        ],
        banner: 'assets/images/departments_categories/QuesosSalchichoneria/Departamento_Quesos_Salchichoneria_alsuper.jpg'
    },
    {
        label: 'DEPARTMENTS.beverage',
        icon: 'ic-beverage',
        route: 'beverage',
        open: false,
        queryParam: 'BEBIDAS DE FRUTAS, BEBIDAS SUAVES',
        sections: [
            {
                queryParam: 'REFRESCOS',
                label: 'DEPARTMENTS.sodas',
                mini: 'assets/images/departments_categories/JugosBebidas/Categorias/SubcategoriaRefrescosBebidas.jpg',
                banner: 'assets/images/departments_categories/JugosBebidas/Categorias/Banner_SubcategoriaRefrescosBebidas.jpg'
            },
            {
                queryParam: 'JUGOS Y NECTARES, BEBIDAS DE FRUTAS, JUGOS',
                label: 'DEPARTMENTS.juices',
                mini: 'assets/images/departments_categories/JugosBebidas/Categorias/SubcategoraAguasJugosNectares.jpg',
                banner: 'assets/images/departments_categories/JugosBebidas/Categorias/Banner_SubcategoriaAguasJugosNectares.jpg'
            }
        ],
        banner: 'assets/images/departments_categories/JugosBebidas/Departamento_Jugos_Bebidas_alsuper.jpg'
    },
    {
        label: 'DEPARTMENTS.bread',
        icon: 'ic-bread',
        route: 'bread',
        open: false,
        queryParam: 'PAN DE CAJA, PAN DE DULCE',
        sections: [
            {
                queryParam: 'PAN DE CAJA, TORTILLA DE MAÍZ',
                label: 'DEPARTMENTS.bakery',
                mini: 'assets/images/departments_categories/PanaderiaTortilleria/Categorias/SubcategoriaPanaderia.jpg',
                banner: 'assets/images/departments_categories/PanaderiaTortilleria/Categorias/Banner_SubcategoriaPanaderia.jpg'
            },
            {
                queryParam: 'TORTILLA DE MAÍZ, TORTILLAS DE HARINA',
                label: 'DEPARTMENTS.tortilla',
                mini: 'assets/images/departments_categories/PanaderiaTortilleria/Categorias/SubcategoriaTortilleria.jpg',
                banner: 'assets/images/departments_categories/PanaderiaTortilleria/Categorias/Banner_SubcategoriaTortilleria.jpg'
            }
        ],
        banner: 'assets/images/departments_categories/PanaderiaTortilleria/Departamento_Panaderia_Tortilleria_alsuper.jpg'
    },
    {
        label: 'DEPARTMENTS.frozenFood',
        icon: 'ic-frozen',
        route: 'frozen',
        open: false,
        queryParam: 'REFRIGERADOS',
        banner: ''
    },
    {
        label: 'DEPARTMENTS.preparedFood',
        icon: 'ic-prepared',
        route: 'prepared',
        open: false,
        queryParam: 'COMIDA PREPARADA',
        sections: [
            {
                queryParam: 'COMIDA PREPARADA',
                label: 'DEPARTMENTS.bistro1',
                mini: 'assets/images/departments_categories/AlimentosPreparados/Categorias/SubcategoriaCocinaBistro.jpg',
                banner: 'assets/images/departments_categories/AlimentosPreparados/Categorias/Banner_SubcategoriaCocinaBistro.jpg'
            },
            {
                queryParam: 'COMIDA PREPARADA',
                label: 'DEPARTMENTS.bistro2',
                mini: 'assets/images/departments_categories/AlimentosPreparados/Categorias/SubcategoriaCocinaBistro2.jpg',
                banner: 'assets/images/departments_categories/AlimentosPreparados/Categorias/Banner_SubcategoriaCocinaBistro2.jpg'
            },
            {
                queryParam: 'COMIDA PREPARADA',
                label: 'DEPARTMENTS.bistro3',
                mini: 'assets/images/departments_categories/AlimentosPreparados/Categorias/SubcategoriaCocinaBistro3.jpg',
                banner: 'assets/images/departments_categories/AlimentosPreparados/Categorias/Banner_SubcategoriaCocinaBistro3.jpg'
            },
            {
                queryParam: 'COMIDA PREPARADA',
                label: 'DEPARTMENTS.bistro4',
                mini: 'assets/images/departments_categories/AlimentosPreparados/Categorias/SubcategoriaCocinaBistro4.jpg',
                banner: 'assets/images/departments_categories/AlimentosPreparados/Categorias/Banner_SubcategoriaCocinaBistro.jpg'
            },
        ],
        banner: 'assets/images/departments_categories/AlimentosPreparados/Departamento_Alimentos_Preparados_alsuper.jpg'
    },
    {
        label: 'DEPARTMENTS.alcohol',
        icon: 'ic-beer',
        route: 'alcohol',
        open: false,
        queryParam: 'CERVEZA, VINO, LICORES',
        sections: [
            {
                queryParam: 'VINOS',
                label: 'DEPARTMENTS.tableWines',
                mini: 'assets/images/departments_categories/CervezasVinosLicores/Categorias/SubcategoriaVinosMesa.jpg',
                banner: 'assets/images/departments_categories/CervezasVinosLicores/Categorias/Banner_SubcategoriaVinosMesa.jpg'
            },
            {
                queryParam: 'LICORES',
                label: 'DEPARTMENTS.liqueur',
                mini: 'assets/images/departments_categories/CervezasVinosLicores/Categorias/SubcategoriaLicoresAguardientes.jpg',
                banner: 'assets/images/departments_categories/CervezasVinosLicores/Categorias/Banner_SubcategoriaLicoresAguardientes.jpg'
            },
            {
                queryParam: 'VINOS GENEROSOS',
                label: 'DEPARTMENTS.generousWines',
                mini: 'assets/images/departments_categories/CervezasVinosLicores/Categorias/SubcategoriaVinosGenerosos.jpg',
                banner: 'assets/images/departments_categories/CervezasVinosLicores/Categorias/Banner_SubcategoriaVinosGenerosos.jpg'
            },
            {
                queryParam: 'CERVEZA',
                label: 'DEPARTMENTS.beer',
                mini: 'assets/images/departments_categories/CervezasVinosLicores/Categorias/SubcategoriaCervezaBebidasAlcohol.jpg',
                banner: 'assets/images/departments_categories/CervezasVinosLicores/Categorias/Banner_SubcategoriaCervezaBebidasConAlcohol.jpg'
            }
        ],
        banner: 'assets/images/departments_categories/CervezasVinosLicores/Departamento_Cervezas_Vinos_Licores_alsuper.jpg'
    },
    {
        label: 'DEPARTMENTS.pharmacy',
        icon: 'ic-meds',
        route: 'pharmacy',
        open: false,
        queryParam: 'MEDICAMENTO OTC',
        sections: [
            {
                queryParam: 'MEDICAMENTO OTC IVA',
                label: 'DEPARTMENTS.genericMeds',
                mini: 'assets/images/departments_categories/Farmacia/Categorias/SubcategoriaMedicamentosPatenteGenericos.jpg',
                banner: 'assets/images/departments_categories/Farmacia/Categorias/Banner_SubcategoriaMedicamentosPatenteGenericos.jpg'
            },
            {
                queryParam: 'DIABETICOS SALUDABLES IVA',
                label: 'DEPARTMENTS.healthy',
                mini: 'assets/images/departments_categories/Farmacia/Categorias/SubcategoriaMedicamentosSaludables.jpg',
                banner: 'assets/images/departments_categories/Farmacia/Categorias/Banner_SubcategoriaMedicamentosSaludables.jpg'
            },
            {
                queryParam: 'CUIDADO CORPORAL',
                label: 'DEPARTMENTS.bodyCare',
                mini: 'assets/images/departments_categories/Farmacia/Categorias/SubcategoriaCorporal.jpg',
                banner: 'assets/images/departments_categories/Farmacia/Categorias/Banner_SubcategoriaCorporal.jpg'
            },
            {
                queryParam: 'MATERIAL DE CURACION IVA',
                label: 'DEPARTMENTS.healingMaterial',
                mini: 'assets/images/departments_categories/Farmacia/Categorias/SubcategoriaMaterialCuracion.jpg',
                banner: 'assets/images/departments_categories/Farmacia/Categorias/Banner_SubcategoriaMaterialCuracion.jpg'
            },
            {
                queryParam: 'MEDICAMENTO OTC IVA',
                label: 'DEPARTMENTS.medicines',
                mini: 'assets/images/departments_categories/Farmacia/Categorias/SubcategoriaMedicamentos.jpg',
                banner: 'assets/images/departments_categories/Farmacia/Categorias/Banner_SubcategoriaMedicamentos.jpg'
            },
            {
                queryParam: 'SALUD SEXUAL IVA',
                label: 'DEPARTMENTS.sexualHealth',
                mini: 'assets/images/departments_categories/Farmacia/Categorias/SubcategoriaSaludSexual.jpg',
                banner: 'assets/images/departments_categories/Farmacia/Categorias/Banner_SubcategoriaSaludSexual.jpg'
            },
            {
                queryParam: 'REHABILITACION',
                label: 'DEPARTMENTS.rehab',
                mini: 'assets/images/departments_categories/Farmacia/Categorias/SubcategoriaRehabilitacion.jpg',
                banner: 'assets/images/departments_categories/Farmacia/Categorias/Banner_SubcategoriaRehabilitacion.jpg'
            },
            {
                queryParam: 'INCONTINENCIA',
                label: 'DEPARTMENTS.incontinence',
                mini: 'assets/images/departments_categories/Farmacia/Categorias/SubcategoriaIncontinencia.jpg',
                banner: 'assets/images/departments_categories/Farmacia/Categorias/Banner_SubcategoriaIncontinencia.jpg'
            }
        ],
        banner: 'assets/images/departments_categories/Farmacia/Departamento_Farmacia_alsuper.jpg'
    },
    {
        label: 'DEPARTMENTS.personalCleanliness',
        icon: 'ic-personal-cleanliness',
        route: 'personal-cleanliness',
        open: false,
        queryParam: 'CUIDADO PERSONAL',
        sections: [
            {
                queryParam: 'CUIDADO PERSONAL',
                label: 'DEPARTMENTS.personalCare',
                mini: 'assets/images/departments_categories/HigienePersonalBelleza/Categorias/SubcategoriaCuidadoPersonal.jpg',
                banner: 'assets/images/departments_categories/HigienePersonalBelleza/Categorias/Banner_SubcategoriaCuidadoPersonal.jpg'
            },
            {
                queryParam: 'COSMETICOS',
                label: 'DEPARTMENTS.cosmetics',
                mini: 'assets/images/departments_categories/HigienePersonalBelleza/Categorias/SubcategoriaCosmeticosAfeitado.jpg',
                banner: 'assets/images/departments_categories/HigienePersonalBelleza/Categorias/Banner_SubcategoriaCosmeticosAfeitado.jpg'
            },
            {
                queryParam: 'CUIDADO DEL CABELLO',
                label: 'DEPARTMENTS.hairCare',
                mini: 'assets/images/departments_categories/HigienePersonalBelleza/Categorias/SubcategoriaCuidadoCabello.jpg',
                banner: 'assets/images/departments_categories/HigienePersonalBelleza/Categorias/Banner_SubcategoriaCuidadoCabello.jpg'
            },
            {
                queryParam: 'HIGIENE FEMENINA',
                label: 'DEPARTMENTS.feminineTowels',
                mini: 'assets/images/departments_categories/HigienePersonalBelleza/Categorias/Banner_SubcategoriaToallas.jpg',
                banner: 'assets/images/departments_categories/HigienePersonalBelleza/Categorias/Banner_SubcategoriaToallas.jpg'
            }
        ],
        banner: 'assets/images/departments_categories/HigienePersonalBelleza/Banner_Departamento_Higiene_Personal_Belleza_alsuper.jpg'
    },
    {
        label: 'DEPARTMENTS.laundryCleaning',
        icon: 'ic-detergent',
        route: 'laundry-cleaning',
        open: false,
        queryParam: 'LIMPIEZA',
        sections: [
            {
                queryParam: 'AROMATIZANTES',
                label: 'DEPARTMENTS.flavorings',
                mini: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/SubcategoriaAromatizantes.jpg',
                banner: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/Banner_SubcategoriaAromatizantes.jpg'
            },
            {
                queryParam: 'MATERIAL ARTS. DE LIMPIEZA',
                label: 'DEPARTMENTS.cleaningItems',
                mini: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/SubcategoriaArticulosLimpieza.jpg',
                banner: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/Banner_SubcategoriaArticulosLimpieza.jpg'
            },
            {
                queryParam: 'BAÑOS',
                label: 'DEPARTMENTS.wc',
                mini: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/SubcategoriaBanos.jpg',
                banner: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/Banner_SubcategoriaBanos.jpg'
            },
            {
                queryParam: 'CUIDADO CALZADO',
                label: 'DEPARTMENTS.footwearCare',
                mini: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/SubcategoriaCuidadoCalzado.jpg',
                banner: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/Banner_SubcategoriaCuidadoCalzado.jpg'
            },
            {
                queryParam: 'DESECHABLES, CARBON Y COMPLEMENTOS',
                label: 'DEPARTMENTS.disposable',
                mini: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/SubcategoriaDesechablesCarbonAccesorios.jpg',
                banner: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/Banner_SubcategoriaDesechablesCarbonAccesorios.jpg'
            },
            {
                queryParam: 'DESINFECTANTES',
                label: 'DEPARTMENTS.disinfectants',
                mini: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/SubcategoriaDesinfectantes.jpg',
                banner: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/Banner_SubcategoriaDesinfectantes.jpg'
            },
            {
                queryParam: 'CUIDADO DE LA ROPA',
                label: 'DEPARTMENTS.detergents',
                mini: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/SubcategoriaDetergentes.jpg',
                banner: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/Banner_SubcategoriaDetergentes.jpg'
            },
            {
                queryParam: 'INSECTICIDAS Y VENENOS',
                label: 'DEPARTMENTS.insecticidesPoisons',
                mini: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/SubcategoriaInsecticidasVenenos.jpg',
                banner: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/Banner_SubcategoriaInsecticidasVenenos.jpg'
            },
            {
                queryParam: 'LIMPIEZA HOGAR',
                label: 'DEPARTMENTS.homeCleaning',
                mini: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/SubcategoriaLimpiezaHogar.jpg',
                banner: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/Banner_SubcategoriaLimpiezaHogar.jpg'
            },
            {
                queryParam: 'PISOS',
                label: 'DEPARTMENTS.floor',
                mini: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/SubcategoriaPisos.jpg',
                banner: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/Banner_SubcategoriaPisos.jpg'
            },
            {
                queryParam: 'SERVILLETAS Y SERVITOALLAS',
                label: 'DEPARTMENTS.napkins',
                mini: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/SubcategoriaServilletasPapelHigienicoPanuelos.jpg',
                banner: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/Banner_SubcategoriaServilletasPapelHigienicoPanuelos.jpg'
            },
            {
                queryParam: 'VIDRIOS',
                label: 'DEPARTMENTS.glasses',
                mini: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/SubcategoriaVidrios.jpg',
                banner: 'assets/images/departments_categories/LavanderiaLimpieza/Categorias/Banner_SubcategoriaVidrios.jpg'
            },
        ],
        banner: 'assets/images/departments_categories/LavanderiaLimpieza/Departamento_Lavanderia_Limpieza_alsuper.jpg'
    },
    {
        label: 'DEPARTMENTS.babies',
        icon: 'ic-babies',
        route: 'babies',
        open: false,
        queryParam: 'BEBES',
        sections: [
            {
                queryParam: 'ACCESORIOS PARA BEBES',
                label: 'DEPARTMENTS.babyAccessories',
                mini: 'assets/images/departments_categories/Bebes/Categorias/SubcategoriaAccesoriosBebe.jpg',
                banner: 'assets/images/departments_categories/Bebes/Categorias/Banner_SubcategoriaAccesoriosBebe.jpg'
            },
            {
                queryParam: 'ALIMENTOS INFANTILES',
                label: 'DEPARTMENTS.babyFood',
                mini: 'assets/images/departments_categories/Bebes/Categorias/SubcategoriaAlimentosInfantiles.jpg',
                banner: 'assets/images/departments_categories/Bebes/Categorias/Banner_SubcategoriaAlimentosInfantiles.jpg'
            },
            {
                queryParam: 'CUIDADO DEL BEBE',
                label: 'DEPARTMENTS.babycare',
                mini: 'assets/images/departments_categories/Bebes/Categorias/SubcategoriaCuidadosBebe.jpg',
                banner: 'assets/images/departments_categories/Bebes/Categorias/Banner_SubcategoriaCuidadosBebe.jpg'
            },
            {
                queryParam: 'PERFUMERIA PARA BEBE',
                label: 'DEPARTMENTS.diapers',
                mini: 'assets/images/departments_categories/Bebes/Categorias/SubcategoriaPanalesToallas.jpg',
                banner: 'assets/images/departments_categories/Bebes/Categorias/Banner_SubcategoriaPanalesToallas.jpg'
            },
        ],
        banner: 'assets/images/departments_categories/Bebes/Departamento_Bebes_alsuper.jpg'
    },
    {
        label: 'DEPARTMENTS.pets',
        icon: 'ic-pets',
        route: 'pets',
        open: false,
        queryParam: 'MASCOTAS',
        sections: [
            {
                queryParam: 'ACCESORIOS MASCOTAS',
                label: 'DEPARTMENTS.petAccessories',
                mini: 'assets/images/departments_categories/Mascotas/Categorias/SubcategoriaAccesoriosAnimales.jpg',
                banner: 'assets/images/departments_categories/Mascotas/Categorias/Banner_SubcategoriaAccesoriosAnimales.jpg'
            },
            {
                queryParam: 'ALIMENTO PARA MASCOTA',
                label: 'DEPARTMENTS.petFood',
                mini: 'assets/images/departments_categories/Mascotas/Categorias/SubcategoriaAlimentoMascotas.jpg',
                banner: 'assets/images/departments_categories/Mascotas/Categorias/Banner_SubcategoriaAlimentoMascotas.jpg'
            },
        ],
        banner: 'assets/images/departments_categories/Mascotas/Departamento_Mascotas_alsuper.jpg'
    },
    {
        label: 'DEPARTMENTS.generalMerchandise',
        icon: 'ic-general',
        route: 'general',
        open: false,
        queryParam: '',
        sections: [
            {
                queryParam: 'ACCESORIOS DECORACIÓN',
                label: 'DEPARTMENTS.accessories',
                mini: 'assets/images/departments_categories/MercanciaGeneral/Categorias/Banner_SubcategoriaAccesorios.jpg',
                banner: 'assets/images/departments_categories/MercanciaGeneral/Categorias/Banner_SubcategoriaAccesorios.jpg'
            },
            {
                queryParam: 'CUIDADO Y LIMPIEZA DE AUTOS',
                label: 'DEPARTMENTS.autos',
                mini: 'assets/images/departments_categories/MercanciaGeneral/Categorias/Banner_SubcategoriaAutos.jpg',
                banner: 'assets/images/departments_categories/MercanciaGeneral/Categorias/Banner_SubcategoriaAutos.jpg'
            },
            {
                queryParam: 'DEPORTES',
                label: 'DEPARTMENTS.sports',
                mini: 'assets/images/departments_categories/MercanciaGeneral/Categorias/Banner_SubcategoriaDeportes.jpg',
                banner: 'assets/images/departments_categories/MercanciaGeneral/Categorias/Banner_SubcategoriaDeportes.jpg'
            },
            {
                queryParam: 'ELECTRODOMÉSTICOS',
                label: 'DEPARTMENTS.electrodomestics',
                mini: 'assets/images/departments_categories/MercanciaGeneral/Categorias/Banner_SubcategoriaElectrodomesticosFerreteria.jpg',
                banner: 'assets/images/departments_categories/MercanciaGeneral/Categorias/Banner_SubcategoriaElectrodomesticosFerreteria.jpg'
            },
            {
                queryParam: 'REGALOS',
                label: 'DEPARTMENTS.entertainment',
                mini: 'assets/images/departments_categories/MercanciaGeneral/Categorias/SubcategoriaEntretenimiento.jpg',
                banner: 'assets/images/departments_categories/MercanciaGeneral/Categorias/Banner_SubcategoriaEntretenimiento.jpg'
            },
            {
                queryParam: 'CUADERNOS Y PAPELERIA',
                label: 'DEPARTMENTS.school',
                mini: 'assets/images/departments_categories/MercanciaGeneral/Categorias/SubcategoriaEscolar.jpg',
                banner: 'assets/images/departments_categories/MercanciaGeneral/Categorias/Banner_SubcategoriaEscolar.jpg'
            },
            {
                queryParam: 'HOGAR',
                label: 'DEPARTMENTS.home',
                mini: 'assets/images/departments_categories/MercanciaGeneral/Categorias/SubcategoriaHogar.jpg',
                banner: 'assets/images/departments_categories/MercanciaGeneral/Categorias/Banner_SubcategoriaHogar.jpg'
            },
            {
                queryParam: 'JUEGOS',
                label: 'DEPARTMENTS.games',
                mini: 'assets/images/departments_categories/MercanciaGeneral/Categorias/SubcategoriaJuguetes.jpg',
                banner: 'assets/images/departments_categories/MercanciaGeneral/Categorias/Banner_SubcategoriaJuguetes.jpg'
            },
            {
                queryParam: 'LIBROS, REVISTAS Y PERIODICOS',
                label: 'DEPARTMENTS.booksMagazines',
                mini: 'assets/images/departments_categories/MercanciaGeneral/Categorias/SubcategoriaLibrosRevistasPeriodicos.jpg',
                banner: 'assets/images/departments_categories/MercanciaGeneral/Categorias/Banner_SubcategoriaLibrosRevistasPeriodicos.jpg'
            },
            {
                queryParam: 'ROPA PARA TODA LA FAMILIA',
                label: 'DEPARTMENTS.clothes',
                mini: 'assets/images/departments_categories/MercanciaGeneral/Categorias/SubcategoriaRopa.jpg',
                banner: 'assets/images/departments_categories/MercanciaGeneral/Categorias/Banner_SubcategoriaRopa.jpg'
            }
        ],
        banner: 'assets/images/departments_categories/MercanciaGeneral/Departamento_Mercancias_Generales_alsuper.jpg'
    },
];

export const POINTS_CATALOGUE = [
    {
        points: 200,
        percent: 5
    },
    {
        points: 400,
        percent: 10
    },
    {
        points: 600,
        percent: 15
    },
    {
        points: 800,
        percent: 20
    }
];

export const TIPS = [
    { amount: 20, label: '$ 20', selected: false },
    { amount: 30, label: '$ 30', selected: false },
    { amount: 50, label: '$ 50', selected: false },
    { amount: 0, label: 'GENERAL.other', selected: false }
];

export const ALSUPER_TYPE = [
    { value: 'fresh', image: 'assets/icons/Fresh.svg', filter: 'fresh_market' },
    { value: 'alsuper', image: 'assets/icons/Alsuper.svg', filter: 'alsuper' },
    { value: 'alsuper-plus', image: 'assets/icons/AlsuperPlus.svg', filter: 'alsuper_plus' }
];

export const AVATAR_DEFAULT = {
    id: 'Avatar-28',
    avatar: 'assets/images/avatars/Avatar-28.png'
};

export const AVATAR_LIST = [
    {
        id: 'Avatar-21',
        avatar: 'assets/images/avatars/Avatar-21.png'
    },
    {
        id: 'Avatar-22',
        avatar: 'assets/images/avatars/Avatar-22.png'
    },
    {
        id: 'Avatar-23',
        avatar: 'assets/images/avatars/Avatar-23.png'
    },
    {
        id: 'Avatar-24',
        avatar: 'assets/images/avatars/Avatar-24.png'
    },
    {
        id: 'Avatar-25',
        avatar: 'assets/images/avatars/Avatar-25.png'
    },
    {
        id: 'Avatar-26',
        avatar: 'assets/images/avatars/Avatar-26.png'
    },
    {
        id: 'Avatar-27',
        avatar: 'assets/images/avatars/Avatar-27.png'
    },
    {
        id: 'Avatar-28',
        avatar: 'assets/images/avatars/Avatar-28.png'
    }
];

export const ORDER_DRIVER_STATUS_LIST = [
    {
        status: ['PENDING', 'PICKER_ASSIGNED'],
        title: 'TRACKING.pending',
        description: 'TRACKING.preparingOrder',
        loading: false
    },
    {
        status: ['PICKING'],
        title: 'TRACKING.picking',
        description: 'TRACKING.supplyingOrder',
        loading: false
    },
    {
        status: ['PICKING_DONE', 'PICKUP_DONE', 'RECEIPT_UPLOADED'],
        title: 'TRACKING.POS',
        description: 'TRACKING.orderOnPOS',
        loading: false
    },
    {
        status: ['DRIVER_ASSIGNED', 'DELIVERING'],
        title: 'TRACKING.delivering',
        description: 'TRACKING.deliveringOrder',
        loading: false
    },
    {
        status: ['SHOPPER_ARRIVED', 'DRIVER_ARRIVED'],
        title: 'TRACKING.arrived',
        description: 'TRACKING.orderArrived',
        loading: false
    },
    {
        status: ['DELIVERED'],
        title: 'TRACKING.delivered',
        description: 'TRACKING.orderDelivered',
        loading: false
    },
];

export const ORDER_DELIVERY_STATUS_LIST = [
    {
        status: ['PENDING'],
        title: 'TRACKING.pending',
        description: 'TRACKING.pendingDescription',
        loading: false
    },
    {
        status: ['SHOPPER_GOING_TO_BRANCH'],
        title: 'TRACKING.shopperBranch',
        description: 'TRACKING.shopperGoingBranch',
        loading: false
    },
    {
        status: ['PICKING'],
        title: 'TRACKING.picking',
        description: 'TRACKING.pickingDescription',
        loading: false
    },
    {
        status: ['PICKING_DONE'],
        title: 'TRACKING.readyForPicking',
        description: 'TRACKING.readyForPickingDescription',
        loading: false
    },
    {
        status: ['RECEIPT_UPLOADED'],
        title: 'TRACKING.delivering',
        description: 'TRACKING.deliveringDescription',
        loading: false
    },
    {
        status: ['DELIVERING'],
        title: 'TRACKING.delivering',
        description: 'TRACKING.deliveringDescription',
        loading: false
    },
    {
        status: ['SHOPPER_ARRIVED'],
        title: 'TRACKING.arrived',
        description: 'TRACKING.arrivedDescription',
        loading: false
    },
    {
        status: ['DELIVERED'],
        title: 'TRACKING.delivered',
        description: 'TRACKING.deliveredDescription',
        loading: false
    },
];

export const ORDER_PICKUP_STATUS_LIST = [
    {
        status: ['PENDING'],
        title: 'TRACKING.pending',
        description: 'TRACKING.pendingDescription',
        loading: false
    },
    {
        status: ['PICKER_ASSIGNED'],
        title: 'TRACKING.pickerAssigned',
        description: 'TRACKING.pickerAssignedDescription',
        loading: false
    },
    {
        status: ['PICKING'],
        title: 'TRACKING.picking',
        description: 'TRACKING.pickingDescription',
        loading: false
    },
    {
        status: ['PICKING_DONE'],
        title: 'TRACKING.readyForPicking',
        description: 'TRACKING.readyForPickingDescription',
        loading: false
    },
    {
        status: ['PICKUP_DONE'],
        title: 'TRACKING.pickupDone',
        description: 'TRACKING.pickupDoneDescription',
        loading: false
    },
    {
        status: ['RECEIPT_UPLOADED'],
        title: 'TRACKING.pickupDone',
        description: 'TRACKING.pickupDoneDescription',
        loading: false
    },
    {
        status: ['DELIVERED'],
        title: 'TRACKING.delivered',
        description: 'TRACKING.deliveredDescription',
        loading: false
    }
];

export const AWARDS_STATES_LIST = [
    {
        label: 'Chihuahua<br>Capital',
        value: 'Chihuahua Capital'
    },
    {
        label: 'Laguna',
        value: 'Laguna'
    },
    {
        label: 'Chihuahua<br>Estado',
        value: 'Chihuahua Estado'
    },
    {
        label: 'Saltillo',
        value: 'Saltillo'
    },
    {
        label: 'Durango',
        value: 'Durango'
    },
    {
        label: 'Zacatecas',
        value: 'Zacatecas'
    }
];



export const ORDER_OPTIONS_LIST = [
    {
        id: 0,
        label: 'Mejor resultado',
        value: '',
        type: 'result',
    },
    {
        id: 1,
        label: 'A a la Z',
        value: 'ASC',
        type: 'name',
    },
    {
        id: 2,
        label: 'Z a la A',
        value: 'DESC',
        type: 'name',
    },
    {
        id: 3,
        label: 'Menor a mayor precio',
        value: 'ASC',
        type: 'price',
    },
    {
        id: 4,
        label: 'Mayor a menor precio',
        value: 'DESC',
        type: 'price',
    }
];

export const BILLINGS_OPTIONS = [
    { num: '1', name: 'Ingrese los datos de su ticket para generar la factura.' },
    { num: '2', name: 'Registre sus datos fiscales o su RFC si esta ya dado de alta.' },
    { num: '3', name: 'Cuando ya se ha capturado toda la información correcta seleccione “Aceptar”.' },
    { num: '4', name: 'Para poder ver la factura en cada uno de estos formatos, solo se da un click sobre el icono del cual desee ver la factura(PDF o XML).' },
    { num: '5', name: 'Su factura se ha enviado al correo registrado, si desea descargar los archivos por favor seleccione en DESCARGAR.' }
];

export const BILLING_USER_NO_REGISTERED = [
    'Desde el Kiosco Digital de Servicio al Cliente ingrese su RFC y teclee sus datos fiscales.',
    'Pase su ticket por el lector óptico y espere ahí mismo la impresión de la factura.',
    'Si desea que enviemos una copia a su correo electrónico, teclee su cuenta de correo y le llegará la factura de forma digital.'
];

export const BILLING_USER_REGISTERED = [
    'Solicite su factura desde la caja, cuando el cajero termine de marcar su mandado que desea factura su compra.',
    'El cajero debe ingresar el número del cliente y la factura se envía a un correo electrónico previamente registrado. Si no tiene una cuenta de correo registrada, puede recoger su impresión en nuestro Kiosco Digital.'
];

export const HEALTHY_CARDS = [
    { label: 'Nuestro grupo es moderado por una nutrióloga profesional, quien se asegurará de que la información que se postee sea verídica.', url: 'assets/icons/ic-healthy-1.svg' },
    { label: 'Nuestra nutrióloga profesional subirá contenidos para nutrir el grupo con información relevante y contestará tus dudas e inquietudes acerca de los contenidos.', url: 'assets/icons/ic-healthy-2.svg' }
];

export const HEALTHY_POINTS = [
    { name: 'Es un espacio donde puedes encontrar a otras personas que están buscando lo mismo que tú.', num: '1' },
    { name: 'Ten un cuerpo más sano.', num: '2' },
    { name: 'Cambia tus hábitos y alternativas que te ayuden a mejorar tu alimentación.', num: '3' },
    { name: 'Obtén consejos para el cuidado de tu salud.', num: '4' }
];

export const BENEFITS_OPTIONS = [
    { name: '100% chihuahuense', num: '1' },
    { name: 'Manzana más dulce', num: '2' },
    { name: 'Excelente calidad', num: '3' },
    { name: 'Producción, empaque y comercialización', num: '4' },
    { name: 'Factor humano como principal distintivo', num: '5' }
];

export const CONSUME_LOCAL_CARDS = [
    {
        img: '/assets/images/Casa Establo.png',
        youtube: 'https://www.youtube.com/watch?v=qhsls4Rey-Y'
    },
    {
        img: '/assets/images/Logo_chorizo.png',
        youtube: 'https://www.youtube.com/watch?v=bbk6ZK294CQ'
    },
    {
        img: '/assets/images/Group 11.png',
        youtube: 'https://www.youtube.com/watch?v=oD6Q4a-IJDY'
    },
    {
        img: '/assets/images/Carreta.png',
        youtube: 'https://www.youtube.com/watch?v=T4g9ctSy1ac'
    },
    {
        img: '/assets/images/Lagrimas.png',
        youtube: 'https://www.youtube.com/watch?v=5Hg46wOn7zU'
    },
    {
        img: '/assets/images/Agrosor.png',
        youtube: 'https://www.youtube.com/watch?v=YSAtqBO7R2I'
    }
];

export const ALSUPER_CARDS = [
    {
        intro: 'VALE DE DESPENSA EMPRESARIAL',
        text: 'Es una tarjeta para Empresas que se utiliza como monedero electrónico para depositar los vales de despensa de la nómina a los colaboradores.',
        contentArr: [
            'No se cobran comisiones por dispersiones, ni por las tarjetas.',
            'Contamos con autorización del SAT para emitir vales de despensa.',
            'Emitimos factura deducible de impuestos.',
            'El saldo no tiene vencimiento y es acumulable.',
            'Válida para compras en todas las tiendas de la cadena, Bistro y Mayoreo.',
            'No aplica para compras de alcohol o tabaco.',
            'Al pagar con la tarjeta acumulas puntos Club Alsuper.'
        ],
        img: '../../assets/images/Alsuper-card.jpg'
    },
    {
        intro: 'TARJETA DE REGALO ADMINISTRACIÓN DEL GASTO FAMILIAR',
        text: 'Es una tarjeta para administrar las compras del mandado del hogar.',
        contentArr: [
            'No tiene costo.',
            'Se puede abonar saldo en cualquiera de nuestras tiendas.',
            'Válida para compras en todas las tiendas de la cadena, Bistro y Mayoreo.',
            'El saldo no tiene vencimiento y es acumulable.',
            'Recárgala a partir de $50.00, sin límite.',
            'Al pagar con la tarjeta acumular puntos Club Alsuper.'
        ],
        img: '../../assets/images/Tarjeta-Familiar.jpg'
    },
    {
        intro: 'TARJETA DE REGALO EMPRESARIAL',
        text: 'Es una tarjeta ideal para incentivar a los empleados y colaboradores.',
        contentArr: [
            'No tiene costo.',
            'Se puede abonar saldo en cualquiera de nuestras tiendas.',
            'Válida para compras en todas las tiendas de la cadena, Bistro y Mayoreo.',
            'El saldo no tiene vencimiento y es acumulable.',
            'Recárgala a partir de $50.00, sin límite.',
            'Al pagar con la tarjeta acumular puntos Club Alsuper.'
        ],
        text1: 'Se puede utilizar como:',
        contentArr1: [
            'Bono por puntualidad.',
            'Bono por productividad.',
            'Regalo en fechas especiales.'
        ],
        img: '../../assets/images/Tarjeta-empresar.jpg'
    },
    {
        intro: 'TARJETA DE BODAS',
        text: 'Es una Tarjeta de regalo para los recién casados. Acompáñalos en esta nueva etapa de su vida con su primera despensa juntos.',
        contentArr: [
            'No tiene costo.',
            'Es válida para compras en todas las tiendas de la cadena y Bistro.',
            'Recárgala a partir de $50.00, sin límite.',
            'Lo pueden utilizar como monedero electrónico, más seguro que cargar efectivo.',
            'Al pagar con la tarjeta acumulas puntos Club Alsuper, para obtener descuentos.'
        ],
        img: '../../assets/images/Tarjeta-de-boda.jpg'
    },
    {
        intro: 'TARJETA DE REGALO PARA MAMÁ',
        text: 'Es una tarjeta para administrar las compras del mandado del hogar.',
        contentArr: [
            'No tiene costo.',
            'Se puede abonar saldo en cualquiera de nuestras tiendas.',
            'Válida para compras en todas las tiendas de la cadena, Bistro y Mayoreo.',
            'El saldo no tiene vencimiento y es acumulable.',
            'Recárgala a partir de $50.00, sin límite.',
            'Al pagar con la tarjeta acumulas puntos Club Alsuper.'
        ],
        img: '../../assets/images/Tarjeta-mama.jpg'
    }

];

export const FORMAT_LIST = [
    { name: 'Fresh Market', value: 'fresh_market' },
    { name: 'Alsuper', value: 'alsuper' },
    { name: 'Alsuper Plus', value: 'alsuper_plus' }
];

export const POSITIVE_COMMENTS = [
    'Tuvo un ligero retardo en la entrega!',
    'Poco atento',
    'No reemplazó el producto deseado',
    'Productos en mal estado',
    'Mejorar actitud',
    'Excelente comunicación'
];

export const VERY_POSITIVE_COMMENTS = [
    '¡Entrega puntual!',
    '¡Excelente servicio!',
    '¡Muy buena actitud!',
    'Excelente comunicación',
    'Muy cuidadoso con los productos'
];

export const NEGATIVE_COMMENTS = [
    'No entregó a tiempo',
    'Mala atención',
    'No reemplazó el producto deseado',
    'Productos en mal estado',
    'Mala actitud'
];

export const CUT_LIST_1 = [
    '1/2"',
    '3/4"',
    '1"',
    '1 1/2"',
    '2"'
];
export const CUT_LIST_2 = [
    '1/4"',
    '1/2"',
    '3/4"',
    '1"',
    '1 1/2"'
];
export const CUT_LIST_3 = [
    '1/4"',
    '1/2"',
    '3/4"',
    '1"',
    '1 1/4"'
];
export const CUT_LIST_4 = [
    '2"',
    '1 1/2"',
    '3"',
    '3 1/2"',
    '4"'
];

export const INCHES_EQUIVALENCE = [
    { name: '1/4"', value: 1 },
    { name: '1/2"', value: 2 },
    { name: '3/4"', value: 3 },
    { name: '1"', value: 4 },
    { name: '1 1/4"', value: 5 },
    { name: '1 1/2"', value: 6 },
    { name: '1 3/4"', value: 7 },
    { name: '2"', value: 8 },
    { name: '2 1/4"', value: 9 },
    { name: '2 1/2"', value: 10 },
    { name: '2 3/4"', value: 11 },
    { name: '3"', value: 12 },
    { name: '3 1/4"', value: 13 },
    { name: '3 1/2"', value: 14 },
    { name: '3 3/4"', value: 15 },
    { name: '4"', value: 16 },
];

export const CUTS_IMAGES = [
    '../../assets/icons/cuts/black-angus/BRISKET.png',
    '../../assets/icons/cuts/black-angus/COSTILLA_SIN_HUESO.png',
    '../../assets/icons/cuts/black-angus/DIEZMILLO_SIN_HUESO.png',
    '../../assets/icons/cuts/black-angus/FILETE_DE_RES.png',
    '../../assets/icons/cuts/black-angus/NEW_YORK.png',
    '../../assets/icons/cuts/black-angus/PICANHA.png',
    '../../assets/icons/cuts/black-angus/RIB_EYE_CON_HUESO.png',
    '../../assets/icons/cuts/black-angus/RIB_EYE_PRIME.png',
    '../../assets/icons/cuts/black-angus/RIB_EYE.png',
    '../../assets/icons/cuts/black-angus/T_BONE.png',
    '../../assets/icons/cuts/black-angus/TIRA_DE_ASADO.png',
    '../../assets/icons/cuts/black-angus/TOMAHAWK.png'
];

export const CUTS_IMAGES1 = [
    '../../assets/icons/cuts/grill-choice/AGUJA_NORTENA.png',
    '../../assets/icons/cuts/grill-choice/ARRACHERA_NATURAL.png',
    '../../assets/icons/cuts/grill-choice/CHULETA_AGUJA.png',
    '../../assets/icons/cuts/grill-choice/CHULETA_DE_LOMO.png',
    '../../assets/icons/cuts/grill-choice/COSTILLA_CARGADA.png',
    '../../assets/icons/cuts/grill-choice/COSTILLA_DE_RIB_EYE.png',
    '../../assets/icons/cuts/grill-choice/NEW_YORK.png',
    '../../assets/icons/cuts/grill-choice/RIB_EYE.png',
    '../../assets/icons/cuts/grill-choice/T-BONE.png',
    '../../assets/icons/cuts/grill-choice/TOP_SIRLOIN.png'
];

export const GRILLED_VIDEOS = [
    'https://www.youtube.com/embed/jFW3zbZrfn0',
    'https://www.youtube.com/embed/AC6nFz1cvpM',
    'https://www.youtube.com/embed/yVLbemQFlRI'
];

export const GRILLED_VIDEOS2 = [
    'https://www.youtube.com/embed/qVpBcqp8tbo',
    'https://www.youtube.com/embed/ooGTSoGVFFk',
    'https://www.youtube.com/embed/CpE8G-dAi34'
];

export const TEMPORAL_RECIPES = [
    {
        name: 'Sandwich de costilla cargada',
        min: '45 min',
        pieces: '4 porciones',
        youtubeUrl: 'https://www.youtube.com/watch?v=qimGfkZi8t0',
        image: 'assets/images/Thumbnail_1.jpg'
    },
    {
        name: 'Short Rib con Pasta de Ajo',
        min: '45 min',
        pieces: '4 porciones',
        youtubeUrl: 'https://www.youtube.com/watch?v=iE3FIWaziJQ',
        image: 'assets/images/Thumbnail_2.jpg'
    }
];

export const TEMPORAL_RECIPES2 = [
    {
        name: 'Camarones Baja',
        min: '45 min',
        pieces: '4 porciones',
        youtubeUrl: 'https://www.youtube.com/watch?v=sSJduBMnurM',
        image: 'assets/images/camarones.png'
    },
    {
        name: 'Pollo Listo Para Asar',
        min: '45 min',
        pieces: '4 porciones',
        youtubeUrl: 'https://www.youtube.com/watch?v=xlulhfYpiOs',
        image: 'assets/images/pollo.png'
    }
];

export const RECIPES_CARDS = [
    {
        name: 'Flan Napolitano',
        section: 'Postres',
        time: '1:45 hrs',
        portions: '4 porciones',
        image: 'assets/images/camarones.png'
    },
    {
        name: 'Flan Napolitano',
        section: 'Postres',
        time: '1:45 hrs',
        portions: '4 porciones',
        image: 'assets/images/camarones.png'
    },
    {
        name: 'Flan Napolitano',
        section: 'Postres',
        time: '1:45 hrs',
        portions: '4 porciones',
        image: 'assets/images/camarones.png'
    },
    {
        name: 'Flan Napolitano',
        section: 'Postres',
        time: '1:45 hrs',
        portions: '4 porciones',
        image: 'assets/images/camarones.png'
    },
    {
        name: 'Flan Napolitano',
        section: 'Postres',
        time: '1:45 hrs',
        portions: '4 porciones',
        image: 'assets/images/camarones.png'
    },
    {
        name: 'Flan Napolitano',
        section: 'Postres',
        time: '1:45 hrs',
        portions: '4 porciones',
        image: 'assets/images/camarones.png'
    }
];

export const DEFAULT_IMAGE_URL = '../../assets/images/default-product.svg';

export const VALIDATION_DATA = {
    title: 'Oh no, parece que el tipo de entrega que seleccionaste no está disponible',
    subtitle: 'Por favor, cambia de sucursal o elige otro tipo de entrega',
    opt: '¿Tienes dudas? ¡Contáctanos!',
    buttons: {
        ok: 'Entendido',
        help: 'Ayuda'
    }
};

export const MENU_MOBILE_LIST = [
    {
        name: 'Mi Cuenta',
        icon: 'ic-departments',
        class: '',
        arrow: true,
        redirect: ''
    },
    {
        name: 'Departamentos',
        icon: 'ic-departments',
        class: '',
        arrow: true,
        redirect: ''
    },
    {
        name: 'Club Alsuper',
        icon: 'ic-departments',
        class: 'club-alsuper',
        arrow: true,
        redirect: ''
    },
    {
        name: 'Ofertas',
        icon: 'ic-offers',
        class: '',
        arrow: false,
        redirect: 'ofertas'
    },
    {
        name: 'Listas',
        icon: 'ic-lists-menu',
        class: '',
        arrow: false,
        redirect: 'listas-alsuper'
    },
    {
        name: 'Centro de ayuda',
        icon: 'ic-help-menu',
        class: '',
        arrow: false,
        redirect: 'ayuda'
    }
];
